<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="container-fluid" *ngIf="accessService.hasAccess([], ['payments.menu'])">
  <div class="d-flex justify-content-between align-items-center">
    <h5 class="title-secondary">
      {{ 'HOTEL_BOOKING_PAYMENTS.HOTEL_BOOKING_PAYMENTS_LIST.TITLE' | translate }}
    </h5>

    <button type="button" class="btn btn-link btn-clear-filters" (click)="clearFilters()">
      {{ 'CLEAR_FILTERS' | translate }}
    </button>
  </div>

  <kendo-grid
    [data]="data"
    [pageSize]="paymentsResponse?.meta.per_page"
    [sortable]="true"
    [filterable]="true"
    [columnMenu]="true"
    [filter]="state?.filter"
    [sort]="state?.sort"
    [skip]="state?.skip"
    [pageable]="true"
    (dataStateChange)="loadData($event)"
    (columnVisibilityChange)="onVisibilityChange($event)"
    #grid
    (excelExport)="onExcelExport($event, 'Hotel_Booking_Payments', grid)"
  >
    <kendo-grid-column
      [width]="70"
      class="text-center"
      headerClass="text-center"
      [title]="'HOTEL_BOOKING_PAYMENTS.HOTEL_BOOKING_PAYMENTS_LIST.NUMBER' | translate"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ rowIndex + 1 }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="hotelBooking.hotel.name"
      filter="text"
      [title]="'HOTEL_BOOKING_PAYMENTS.HOTEL_BOOKING_PAYMENTS_LIST.HOTEL_NAME' | translate"
      [hidden]="isHiddenColumn('hotelBooking.hotel.name')"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-universal-input field="hotelName" [filter]="filter"></app-kendo-universal-input>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem?.paymentable?.hotel?.name }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="hotelBooking.events"
      [title]="'HOTEL_BOOKING_PAYMENTS.HOTEL_BOOKING_PAYMENTS_LIST.EVENT_YEAR' | translate"
      [filterable]="true"
      [sortable]="false"
      [hidden]="isHiddenColumn('hotelBooking.events')"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-event-select [filter]="filter" [field]="'hotelBooking.events.id'"></app-kendo-event-select>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        <div *ngFor="let event of dataItem.paymentable?.events">
          {{ event.name }}
          {{ event.date_from | amDateFormat : 'YYYY' }}
        </div>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="hotelBooking.supplier.name"
      filter="text"
      [title]="'HOTEL_BOOKING_PAYMENTS.HOTEL_BOOKING_PAYMENTS_LIST.SUPPLIER' | translate"
      [hidden]="isHiddenColumn('hotelBooking.supplier.name')"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-universal-input field="supplierName" [filter]="filter"></app-kendo-universal-input>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.paymentable?.supplier?.name }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="paymentable.company.abbreviation"
      filter="text"
      [title]="'HOTEL_BOOKING_PAYMENTS.HOTEL_BOOKING_PAYMENTS_LIST.BOOKING_OFFICE' | translate"
      [hidden]="isHiddenColumn('paymentable.company.id')"
      [filterable]="false"
      [sortable]="false"
      width="50"
      [columnMenu]="false"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.paymentable?.company?.abbreviation }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="paymentable.ref_number"
      filter="text"
      [title]="'HOTEL_BOOKING_PAYMENTS.HOTEL_BOOKING_PAYMENTS_LIST.REF_NUMBER' | translate"
      [sortable]="false"
      [filterable]="false"
      [hidden]="isHiddenColumn('paymentable.ref_number')"
      width="150"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.paymentable?.ref_number }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="date"
      filter="date"
      format="{0:dd/MM/yyyy}"
      [title]="'HOTEL_BOOKING_PAYMENTS.HOTEL_BOOKING_PAYMENTS_LIST.DATE' | translate"
      [hidden]="isHiddenColumn('date')"
      width="140"
    >
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="eq"></kendo-grid-date-filter-cell>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.date | amDateFormat : env.momentDateFormat }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="hotelBooking.payment_deadline"
      filter="date"
      format="{0:dd/MM/yyyy}"
      [title]="'HOTEL_BOOKING_PAYMENTS.HOTEL_BOOKING_PAYMENTS_LIST.PAYMENT_DEADLINE' | translate"
      [hidden]="isHiddenColumn('hotelBooking.payment_deadline')"
      width="140"
    >
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="eq"></kendo-grid-date-filter-cell>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.paymentable?.payment_deadline | amDateFormat : env.momentDateFormat }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="hotelBooking.cancellation_deadline"
      filter="date"
      format="{0:dd/MM/yyyy}"
      [title]="'HOTEL_BOOKING_PAYMENTS.HOTEL_BOOKING_PAYMENTS_LIST.CANCELLATION_DEADLINE' | translate"
      [hidden]="isHiddenColumn('hotelBooking.cancellation_deadline')"
      [sortable]="false"
      width="140"
    >
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="eq"></kendo-grid-date-filter-cell>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.paymentable?.cancellation_deadline | amDateFormat : env.momentDateFormat }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="hotelBooking.rooms.check_in"
      filter="fate"
      format="{0:dd/MM/yyyy}"
      [title]="'HOTEL_BOOKING_PAYMENTS.HOTEL_BOOKING_PAYMENTS_LIST.CHECK_IN' | translate"
      [hidden]="isHiddenColumn('hotelBooking.rooms_earliest.check_in')"
      width="120"
    >
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="eq"></kendo-grid-date-filter-cell>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem?.paymentable?.rooms_earliest.check_in | amDateFormat : env.momentDateFormat }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="amount"
      filter="numeric"
      [title]="'HOTEL_BOOKING_PAYMENTS.HOTEL_BOOKING_PAYMENTS_LIST.AMOUNT' | translate"
      [hidden]="isHiddenColumn('amount')"
      width="95"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <div>
          <ng-container *ngIf="paymentTypes.EXPENSE === dataItem?.type_id"> - </ng-container>
          {{ dataItem.amount | number : '1.2-2' }}
          <app-currency-box [currency]="dataItem?.currency"></app-currency-box>
        </div>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="hotelBooking.reservation_agent.fake_first_name"
      [title]="'HOTEL_BOOKING_PAYMENTS.HOTEL_BOOKING_PAYMENTS_LIST.RESERVATIONS_AGENT' | translate"
      [hidden]="isHiddenColumn('hotelBooking.reservation_agent.fake_first_name')"
      width="120"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-user-select
          [filter]="filter"
          [roleType]="[UserRoleType.RESERVATION_AGENT]"
          field="reservationAgentId"
        ></app-kendo-user-select>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.paymentable?.reservation_agent?.fake_first_name }}
        {{ dataItem.paymentable?.reservation_agent?.fake_last_name }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="hotelBooking.contracting_agent.fake_first_name"
      [title]="'HOTEL_BOOKING_PAYMENTS.HOTEL_BOOKING_PAYMENTS_LIST.CONTRACTING_AGENT' | translate"
      [hidden]="isHiddenColumn('hotelBooking.contracting_agent.fake_first_name')"
      width="120"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-user-select
          [filter]="filter"
          [roleType]="[UserRoleType.CONTRACTING_AGENT]"
          field="contractingAgentId"
        ></app-kendo-user-select>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.paymentable?.contracting_agent?.fake_first_name }}
        {{ dataItem.paymentable?.contracting_agent?.fake_last_name }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="is_paid"
      filter="boolean"
      [title]="'HOTEL_BOOKING_PAYMENTS.HOTEL_BOOKING_PAYMENTS_LIST.IS_PAID' | translate"
      [class]="'text-center'"
      [hidden]="isHiddenColumn('is_paid')"
      width="100"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <app-active-indicator [active]="dataItem.is_paid"></app-active-indicator>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      [title]="'HOTEL_BOOKING_PAYMENTS.HOTEL_BOOKING_PAYMENTS_LIST.ACTIONS' | translate"
      width="100"
      [class]="'text-center'"
      [includeInChooser]="false"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <app-edit-button (click)="edit(dataItem)"></app-edit-button>

        <app-activities-button [subjectType]="LaravelModels.PAYMENT" [subjectId]="dataItem.id"></app-activities-button>

        <app-media-library-button
          [ngbTooltip]="'HOTEL_BOOKING_PAYMENTS.HOTEL_BOOKING_PAYMENTS_LIST.UPLOAD_DOCUMENTS' | translate"
          container="body"
          [modelId]="dataItem.id"
          [modelType]="LaravelModels.PAYMENT"
          [collectionName]="'files'"
          [acceptType]="MediaLibraryAcceptTypes.ALL"
          [icon]="'fal fa-file'"
        ></app-media-library-button>

        <app-delete-button [swal]="{}" (confirm)="delete(dataItem)"></app-delete-button>

        <app-preview-button
          *ngIf="
            accessService.hasAccess(
              [
                UserRoleType.RESERVATION_AGENT,
                UserRoleType.RESERVATION_MANAGER,
                UserRoleType.CONTRACTING_AGENT,
                UserRoleType.CONTRACTING_MANAGER,
                UserRoleType.SALES_AGENT,
                UserRoleType.SALES_MANAGER,
                UserRoleType.CUSTOMER_CARE_AGENT,
                UserRoleType.CUSTOMER_CARE_MANAGER,
                UserRoleType.FINANCE_AGENT,
                UserRoleType.FINANCE_MANAGER,
                UserRoleType.LEAD_GENERATION,
                UserRoleType.IT,
                UserRoleType.MARKETING
              ],
              ['hotel_bookings.show']
            )
          "
          [link]="['/hotel-bookings/view']"
          [params]="{ id: dataItem.paymentable?.id }"
        >
        </app-preview-button>
      </ng-template>
    </kendo-grid-column>

    <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
      <kendo-pager-input></kendo-pager-input>
      <kendo-pager-info></kendo-pager-info>
      <kendo-pager-next-buttons></kendo-pager-next-buttons>
      <kendo-pager-page-sizes [pageSizes]="env.kendoGridPageSizes"></kendo-pager-page-sizes>
      <app-kendo-grid-refresh-button (click)="loadData(state)"></app-kendo-grid-refresh-button>
      <button type="button" class="btn kendo-export-btn" [disabled]="grid.loading" kendoGridExcelCommand>
        {{ 'EXPORT_TO_EXCEL' | translate }}
      </button>
    </ng-template>

    <kendo-grid-excel></kendo-grid-excel>
  </kendo-grid>
</div>
